
import FIcon from '@fixit/icons/src/components/FIcon.vue'

    export default {
        components: { FIcon },
        props: {
            news: {
                type: Array,
                default: null
            },
        },
        data: () => ({
            isMounted: false,
        }),
        mounted() {
            this.isMounted = true;
        },
        methods: {
            getImage(item) {
            if (item == null || item.imgUrl == null || item.imgUrl === undefined) {
              return null
            }
            if (typeof String.prototype.replaceAll == "undefined") {
              String.prototype.replaceAll = function(match, replace) {
                return this.replace(new RegExp(match, 'g'), () => replace);
              }
            }
            return item.imgUrl.replaceAll('"', '')
            },
        },
    }
